const timeout = 1000 * 60 * 15 // 10 min

const idleChecker = function (app) {
  let timer
  let active = true

  // DOM Events
  document.addEventListener('DOMContentLoaded', resetTimer)
  document.addEventListener('mousedown', resetTimer)
  document.addEventListener('mousemove', resetTimer)
  document.addEventListener('keydown', resetTimer)
  document.addEventListener('resize', resetTimer)
  document.addEventListener('touchstart', resetTimer)
  document.addEventListener('wheel', resetTimer)

  function logout() {
    clearTimeout(timer)
    active = false
    app.$http.get('users/logout')
    app.$user.logout()
    app.$router.push('/login')
  }

  function resetTimer() {
    clearTimeout(timer)
    if (active)
      timer = setTimeout(logout, timeout)
  }
}

export default idleChecker



// WEBPACK FOOTER //
// ./client/src/idle.js